import React from "react";
import { css } from "emotion";
import { dynamicRange } from "./style";
import SliderDynamicRange from "../../../../shared/SliderDynamicRange/SliderDynamicRange";
import { intFormat } from "../../../../shared/create-offer/utils/formats";

export const DynamicRange = props => {
	const {
		averageMiles,
		validRange,
		startAverage,
		endAverage,
		bestAverage,
		changeAverageSlider,
		textRange
	} = props;

	return (
		<div
			className={css`
				${dynamicRange}
			`}
		>
			<form className="form-offer block-center dynamic-range">
				<p className="dynamic-range--text">
					{textRange ? (
						textRange
					) : (
						<>
							Arraste e defina a média entre {intFormat(startAverage)} e {intFormat(endAverage)}{" "}
							para aumentar o valor de cada 1.000 milhas para R$ 33,50.
						</>
					)}
				</p>
				<p>
					Média atual: <strong className="miles">{intFormat(averageMiles)}</strong>
				</p>

				<div className="dynamic-range--slider d-flex">
					<SliderDynamicRange
						min={0}
						max={startAverage + endAverage}
						rangeMin={startAverage}
						rangeMax={endAverage}
						step={500}
						defaultValue={bestAverage}
						onChange={changeAverageSlider}
						validRange={validRange}
						className="slider-dynamic-range-component"
						id="average_slider"
						name="average_slider"
						value={averageMiles}
					/>
				</div>
			</form>
		</div>
	);
};

export default DynamicRange;
